<template>
  <div class="panel-body" v-if="getClients">
    <form>
      <vue-form-generator
        ref="form"
        :schema="schema"
        :model="model"
        :options="formOptions"
        @validated="onValidated"
      >
      </vue-form-generator>
    </form>
  </div>
</template>

<script>
/*eslint-disable*/
import Vue from "vue";
import moment from "moment";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
Vue.use(VueFormGenerator);
export default {
  beforeRouteEnter (to, from, next) {
  next(vm => {
    if(to.params && to.params.data && to.params.data.length > 0) {
      vm.model = to.params.data[0];
    }
    if (to.params.editMode) {
      vm.editMode = to.params.editMode
      const idField = vm.schema.groups[0].fields.find((item)=>{
        return item.model === "id"
      });
      idField.readonly = true;
    }
  })
},
  created() {
    this.schema.groups[0].fields[1].values = this.getStringClients;
  },
  data() {
    return {
      isValid : false,
      editModel: false,
      model: {
        id: null,
        comapnySelected: null,
        status: true,
        startDate: null,
        endDate: null
      },

      schema: {
        groups: [
          {
            legend: "Ugovor",
            fields: [
              {
                type: "input",
                inputType: "text",
                label: "Sifra ugovora",
                placeholder: "npr. #001",
                model: "id",
                required: true,
                validator: VueFormGenerator.validators.string
              },
              {
                type: "select",
                label: "Izaberite klijenta",
                model: "comapnySelected",
                values: this.getStringClients,
                required: true,
                validator: VueFormGenerator.validators.string
              },
              {
                type: "input",
                inputType: "date",
                model: "startDate",
                label: "Datum potpisivanja ugovora",
                required: true,
                validator: VueFormGenerator.validators.date
              },
              {
                type: "input",
                inputType: "date",
                model: "endDate",
                label: "Datum isteka ugovora",
                required: true,
                set: function(model, val) {
                  model.endDate = val;
                  if (model.endDate < model.startDate) {
                    model.endDate = model.startDate + 86400000;
                  }
                },
                validator: VueFormGenerator.validators.date

              },
              {
                type: "submit",
                label: "",
                buttonText: "Submit",
                validateBeforeSubmit: true,
                onSubmit: this.createContract
              }
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: false,
      }
    };
  },
  methods: {
    createContract() {
      if(this.editMode) {
        this.$store.dispatch('editContract', this.model);
      } else {
        this.$store.dispatch('createNewContract', this.model);
      }
    },
    onValidated(isValid, errors) {
      this.isValid = isValid;
    },
    validate() {
      return this.$refs.form.validate();
    }
  },
  computed: {
    getClients() {
      return this.$store.getters.getClients;
    },
    getStringClients() {
      var arr = [];
      this.getClients.forEach(item => {
        arr.push(item.companyName);
      });
      return arr;
    }
  }
};
</script>

<style>
@import "./../../../node_modules/pikaday/css/pikaday.css";
</style>
